import { render, staticRenderFns } from "./PanproofSrc.vue?vue&type=template&id=0e1aceaa"
import script from "./PanproofSrc.vue?vue&type=script&lang=js"
export * from "./PanproofSrc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports